import { useEffect, useRef } from 'react';

// eslint-disable-next-line prettier/prettier
export const usePreviousValue = <T,>(value: T): T | undefined => {
  const ref = useRef<T>(undefined);

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
